module.exports = __webpack_public_path__ + "images/led_gray.gif";